/* MICROLOGY — loest die Gesten einmal aus, sobald sie sichtbar werden; zaehlt Zahlen hoch; erzeugt Punkte unter Wisch-Reihen */
(function () {
  if (window.mcGestures) { window.mcGestures.scan(document); return; }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('mc-in'); io.unobserve(e.target); } });
  }, { threshold: .35 });
  var cio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      cio.unobserve(e.target);
      var el = e.target, to = +el.getAttribute('data-count'), t0 = null, dur = to > 9 ? 1400 : 900;
      if (reduce || !to) { el.textContent = to; return; }
      function step(t) { if (!t0) t0 = t; var k = Math.min((t - t0) / dur, 1); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); }
      el.textContent = '0'; requestAnimationFrame(step);
    });
  }, { threshold: .8 });
  function swipe(row) {
    if (row.getAttribute('data-mc-dots')) return;
    row.setAttribute('data-mc-dots', '1');
    var n = row.children.length, d = document.createElement('div');
    d.className = 'mc-dots'; d.setAttribute('aria-hidden', 'true');
    for (var k = 0; k < n; k++) { var i = document.createElement('i'); if (!k) i.className = 'on'; d.appendChild(i); }
    row.parentNode.insertBefore(d, row.nextSibling);
    var dots = Array.prototype.slice.call(d.children);
    row.addEventListener('scroll', function () {
      var w = row.children[0].getBoundingClientRect().width + 14, k = Math.min(Math.round(row.scrollLeft / w), n - 1);
      dots.forEach(function (x, j) { x.classList.toggle('on', j === k); });
    }, { passive: true });
  }
  function scan(root) {
    root.querySelectorAll('[data-mc-in]').forEach(function (el) { if (reduce) el.classList.add('mc-in'); else io.observe(el); });
    root.querySelectorAll('[data-count]').forEach(function (el) { cio.observe(el); });
    root.querySelectorAll('.mc-swipe').forEach(swipe);
  }
  window.mcGestures = { scan: scan };
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();